import React from 'react';
import { Container, Row, Col } from 'shards-react';
import classNames from 'classnames';
import MainNavbar from '../components/layout/MainNavbar';
import MainSidebar from '../components/layout/MainSidebar/MainSidebar';
import EnvBorder from '../components/layout/EnvBorder';
import { RoleBasedGuard } from './RoleBasedGuard';
import { useSelector } from '../redux/store';
import type { Role } from '../types/common';

interface IconSidebarLayoutProps {
  accessibleRoles: Role[];
  children: React.ReactChildren;
}

const IconSidebarLayout = ({ accessibleRoles, children }: IconSidebarLayoutProps): React.ReactElement => {
  // console.log(accessibleRoles);
  const { sidebarOpen } = useSelector((state) => state.session);
  const classes = classNames('main-content', 'col', sidebarOpen && 'pushed');

  return (
    <Container fluid className="icon-sidebar-nav">
      <Row>
        <EnvBorder />
        <MainSidebar hideLogoText />
        <Col className={classes} tag="main">
          <MainNavbar />
          <RoleBasedGuard accessibleRoles={accessibleRoles}>{children}</RoleBasedGuard>
        </Col>
      </Row>
    </Container>
  );
};

export default IconSidebarLayout;
